<template>
    <div>
        <p id="alert" class="p-small" :class="successful ? 'alert-success' : 'alert-error'">{{alertMsg}}</p>
    </div>
</template>

<script>

export default {
    name: 'AlertBox',
    props: ['alertMsg', 'successful']
}
</script>

<style>
#alert {
    margin-top: 1rem;
    padding: 0.5rem;
    border-radius: 4px;
    text-align: center;
    background-color: var(--white);
}

.alert-success {
    color: var(--apple-green);
    border: 1px solid var(--apple-green);
}

.alert-error {
    color: var(--red);
    border: 1px solid var(--red);
}

</style>
